import { createTheme } from '@material-ui/core/styles';

const MyTheme = createTheme({
  overrides: {},
});

export default MyTheme;
